export function mapKeys(obj, func) {
    return Object.keys(obj).reduce(function (result, key) {
        var val = obj[key];
        result[func(key, val)] = val;
        return result;
    }, {});
}
export default mapKeys;

//# sourceMappingURL=mapKeys.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/utils/mapKeys.js
// module id = 202
// module chunks = 0